import React, { Component } from 'react'
import styled from 'styled-components';

const DropdownItems = styled.div`
    background-color: #FFF;
    position: absolute;
    border: 1px solid #989FA3;
    ${p => p.padding ? 'padding: 5px;' : ''};
    background-color: #F6F7F7;
    box-shadow: 0 1px 3px #CCCCCC;
    z-index: 100000;
    max-height: ${p => p.maxHeight ? p.maxHeight : "500px"};
    overflow-y: auto;
    ${p => p.fitToSize ? '' : 'width: 100%'};
    ${p => p.rightMode ? 'right: 0' : ''}
    ${p => p.minWidth ? 'min-width:' + p.minWidth + ';' : ''}
    ${p => p.overlap ? 'top: 0;' : ''}
`;

interface DropdownContentProps {
  dropdownOpen?: boolean;
  showDropdown?: (b: boolean) => void;
  maxHeight?: string;
  overlap?: boolean;
  fitToSize?: boolean;
  padding?: number;
  minWidth?: string;
  rightMode?: any;
  closeOnClick?: boolean;
}

// interface DropdownContentState {
//   dropdownOpen: boolean
// }

export default class DropdownContent extends Component<DropdownContentProps> {

  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     dropdownOpen: this.props.dropdownOpenStart,
  //   }
  // }

  // showDropdown(value) {
  //   this.setState({ dropdownOpen: value })
  // }

  render() {
    return (
      this.props.dropdownOpen ?
            <DropdownItems className="dropdown-content" maxHeight={this.props.maxHeight} overlap={this.props.overlap} fitToSize={this.props.fitToSize}
          padding={this.props.padding} minWidth={this.props.minWidth} rightMode={this.props.rightMode}
          onClick={() => this.props.closeOnClick && this.props.showDropdown!(false)} >
          {this.props.children}
        </DropdownItems>
        : null
    )
  }
}
